// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".queryCharge #footer-wrapper .fixedBottom {\n  position: relative;\n  bottom: 0;\n  right: 15px;\n  background: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
